<div>
    <div>
        <a href="http://finance.lacity.org/" target="_blank" title="Home"><img class="logo-1" src="content/images/finance_logo.png"></a>
    </div>
    <div id="background-opacity"></div>
    <div><img class="banner-1 noprint" src="content/images/short_hero.jpg"></div>
</div>